import axios from 'axios'

const baseurl = `${process.env.VUE_APP_API_URL}`
const url = `${baseurl}/api/v1`
class FileService {
  static upload (data) {
    return axios.post(`${url}/app/file/upload`, data)
  }
}

export default FileService
